/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class KPIDOMProvider
 * @hideconstructor
 * @classdesc Implements DOMProviderAPI
 */
define([
	'jquery',
	'./api/DOMProviderAPI',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], ($, DomProviderAPI, APIFactory) => {
	class KPIDOMProvider {

		constructor(options) {
			this._domNode = options.features.ContentViewDOM.getNode();

			this.liveWidgetDOM = options.features.LiveWidgetDOM;
			this.visualization = options.features.Visualization;

			const type = this.visualization.getType();
			if (type === 'KPI'){
				this.liveWidgetDOM.registerProvider(this.getAPI());
			}
		}

		getAPI() {
			if (!this._api) {
				this._api =  APIFactory.createAPI(this, [DomProviderAPI]);
			}
			return this._api;
		}

		/**
		 * @implements DomProviderAPI.getUIJSON
		 */
		getUIJSON() {
			return {
				base: this._retrieve('base'),
				target: this._retrieve('target'),
				time: this._retrieveTime()
			};
		}

		_retrieveTime() {
			const svg = 'div.dataview.kpi-widget > div.kpi-widget-content > div.kpi-widget-sparkline.widget svg.rootSvg';
			const $rect = $(this._domNode).find(`${svg} > g.chart > g.content > rect`);
			const $timeChart = $(this._domNode).find(`${svg} > g.chart > g.content path.line-element`);
			if ($rect.length > 0 && $timeChart.length > 0) {
				return {
					width: $rect.attr('width'),
					height: $rect.attr('height'),
					color: $timeChart.css('stroke')
				};
			}
		}

		_retrieve(slot) {
			const selectorRoot = `div.dataview > div.kpi-widget-content > div.kpi-widget-value.kpi-widget-${slot}-value.labeled-value > div.labeled-value`;
			const $label = $(this._domNode).find(`${selectorRoot}-label > span`);
			if ($label.length > 0) {
				const $value = $(this._domNode).find(`${selectorRoot}-value > span`);
				const $shape = $(this._domNode).find(`${selectorRoot}-value > svg > use`);
				return {
					label: {
						text: $label.text(),
						color: $label.css('color')
					},
					value: {
						text: $value.text(),
						color: $value.css('color'),
						shape: $shape.attr('xlink:href')
					}
				};
			}
		}

	}

	return KPIDOMProvider;
});
